// Email service to handle sending emails
import emailjs from '@emailjs/browser';

const EmailService = {
  // EmailJS credentials.
  // All four values are public by design - they ship in the client bundle and are
  // safe to expose. Override them per environment through .env (see .env.example)
  // to rotate credentials without a code change; the defaults below keep builds
  // working when no .env is present.
  emailjs: {
    serviceId: process.env.VUE_APP_EMAILJS_SERVICE_ID || 'service_l8pgr7y',
    contactTemplateId: process.env.VUE_APP_EMAILJS_CONTACT_TEMPLATE_ID || 'template_qlcnzcs',
    demoTemplateId: process.env.VUE_APP_EMAILJS_DEMO_TEMPLATE_ID || 'template_h6oqn5h',
    publicKey: process.env.VUE_APP_EMAILJS_PUBLIC_KEY || 'TxVX4SJp3QUHYydlW',
  },

  /**
   * Send an email with the provided data
   * @param {Object} emailData - The email data
   * @param {string} emailData.name - Sender's name
   * @param {string} emailData.email - Sender's email
   * @param {string} emailData.subject - Email subject
   * @param {string} emailData.message - Email message content
   * @param {string} [emailData.company] - Sender's company (optional)
   * @param {string} [emailData.phone] - Sender's phone (optional)
   * @param {string} toEmail - The recipient email address (used only in the fallback logging)
   * @returns {Promise<boolean>} - Success status
   */
  async sendEmail(emailData, toEmail = "mashraf@eduval.net") {
    try {
      const templateId = Object.prototype.hasOwnProperty.call(emailData, 'company') || 
                         Object.prototype.hasOwnProperty.call(emailData, 'phone')
                         ? this.emailjs.demoTemplateId
                         : this.emailjs.contactTemplateId;
      
      const templateParams = {
        from_name: emailData.name,
        from_email: emailData.email,
        to_email: toEmail,
        subject: emailData.subject || 'Contact Form Submission',
        message: emailData.message,
        company: emailData.company || 'Not provided',
        phone: emailData.phone || 'Not provided'
      };
      
      console.log(`Sending email to ${toEmail} with EmailJS`, templateParams);
      
      // Use EmailJS to send the email
      const response = await emailjs.send(
        this.emailjs.serviceId,
        templateId,
        templateParams,
        this.emailjs.publicKey
      );
      
      // Check if the email was sent successfully
      if (response.status === 200) {
        console.log('Email sent successfully!', response);
        return true;
      } else {
        console.error('Error sending email:', response);
        return false;
      }
    } catch (error) {
      console.error('Error sending email:', error);
      return false;
    }
  },

  /**
   * Format the email content based on the data type (used for logging)
   * @param {Object} data - The form data
   * @returns {string} - Formatted email content
   */
  formatEmailContent(data) {
    // Determine if it's a demo request or contact form
    const isDemoRequest = Object.prototype.hasOwnProperty.call(data, 'company') || 
                          Object.prototype.hasOwnProperty.call(data, 'phone');
    
    if (isDemoRequest) {
      return `
Demo Request from ${data.name}

Name: ${data.name}
Email: ${data.email}
Company: ${data.company || 'Not provided'}
Phone: ${data.phone || 'Not provided'}

Message:
${data.message}
      `;
    } else {
      return `
Contact Form Submission from ${data.name}

Name: ${data.name}
Email: ${data.email}
Subject: ${data.subject}

Message:
${data.message}
      `;
    }
  }
};

export default EmailService; 